import * as $ from "jquery";
require('paroller.js');
$(document).ready(function () {
    window.setTimeout(() => {
        initParoller();
    }, 2000);
    function initParoller() {
        $(".paroller").paroller({
            factor: -0.1,
            type: 'background',
            direction: 'vertical'
        });
    }
});